var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activation-deliverable-content-approval-provider',{staticStyle:{"height":"100%"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var brief = ref.brief;
    var isLoading = ref.isLoading;
    var errors = ref.errors;
    var errorMessage = ref.errorMessage;
    var onPageClose = ref.onPageClose;
    var deliverable = ref.deliverable;
    var task = ref.task;
    var uploadContentUrl = ref.uploadContentUrl;
    var requiresCaptionApproval = ref.requiresCaptionApproval;
    var handleFileChange = ref.handleFileChange;
    var handleResetUploads = ref.handleResetUploads;
    var uploadHeaders = ref.uploadHeaders;
    var uploadedFiles = ref.uploadedFiles;
    var hasUploadedFiles = ref.hasUploadedFiles;
    var isFileUploading = ref.isFileUploading;
    var handleRefreshDeliverable = ref.handleRefreshDeliverable;
    var goBack = ref.goBack;
return [_c('activation-deliverable-content-approval-view',{attrs:{"brief":brief,"is-loading":isLoading,"errors":errors,"error-message":errorMessage,"deliverable":deliverable,"task":task,"upload-content-url":uploadContentUrl,"requires-caption-approval":requiresCaptionApproval,"handle-file-change":handleFileChange,"upload-headers":uploadHeaders,"uploaded-files":uploadedFiles,"has-uploaded-files":hasUploadedFiles,"is-file-uploading":isFileUploading},on:{"file-change":handleFileChange,"reset-uploads":handleResetUploads,"close":onPageClose,"refresh-deliverable":handleRefreshDeliverable,"back":goBack}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }